/** A participant's estado_registo as a coloured pill. */
export default function ParticipantStatusBadge({ status }: { status: string }) {
  const cls: Record<string, string> = {
    Ativo:    'bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-400',
    Pendente: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/20 dark:text-yellow-400',
    Inativo:  'bg-muted text-muted-foreground',
    Suspenso: 'bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-400',
  };
  return (
    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${cls[status] ?? cls.Inativo}`}>
      {status}
    </span>
  );
}
